import { createSlice } from '@reduxjs/toolkit';

import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { Service } from 'services/Services';
import { RequestApi, RequestApiDisableHead } from 'RequestApi';

const initialState = {
  contacts: [],
  pageCount: 0,
  pageIndex: 0,
  loading: false,
  pageInfo: null,
  fetching: false,
  records: [],
  currentDate: { month: '', year: '' },
  viewingRecord: null,
  progressingDocument: false,
};

const dynamicPageTrainingCalenderSlice = createSlice({
  name: 'dynamicPageTrainingCalender',
  initialState,
  reducers: {
    receiveService(state, action) {
      const { records } = action.payload;
      state.records = records;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },

    setFetching(state, action) {
      state.fetching = action.payload;
    },
    setViewingRecord(state, action) {
      state.viewingRecord = action.payload;
    },
    setProgressingDocument(state, action) {
      state.progressingDocument = action.payload;
    },
    setCurrentDate(state, action) {
      state.currentDate = action.payload;
    },
  },
});
const { setPageInfo, setFetching } = dynamicPageTrainingCalenderSlice.actions;

export const { setViewingRecord, setProgressingDocument, setCurrentDate, receiveService } = dynamicPageTrainingCalenderSlice.actions;

// ----------- Start ------------ //

export const initPageInfo =
  ({ informationPage }) =>
  async (dispatch) => {
    dispatch(setPageInfo(informationPage));
  };

export const fetchRecords =
  ({ url, currentDate }) =>
  async (dispatch) => {
    dispatch(setFetching(true));

    let urlRequest = `${url}/index-table?`;
    urlRequest += `auth_token=${Service.userToken}`;

    const data = JSON.stringify({
      month: currentDate.month,
      year: currentDate.year,
    });

    RequestApi(urlRequest, { data })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status === 'success') {
            dispatch(
              receiveService({
                records: res.data.records,
              })
            );
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
        } else {
          NotificationMessage({ message: res.message, status: 'warning' });
        }
        dispatch(setFetching(false));
      })
      .catch((err) => {
        dispatch(setFetching(false));
        NotificationMessage({ message: err.toString(), status: 'error' });
      });
  };

export const updateWeekNumber = (weekNumber) => async (dispatch) => {
  dispatch(setFetching(true));

  let urlRequest = `/training-calendar-setup/index-table?`;
  urlRequest += `auth_token=${Service.userToken}`;

  const data = JSON.stringify({
    week_number: weekNumber,
  });

  RequestApi(urlRequest, { data })
    .then((res) => {
      if (res.status === 200) {
        if (res.data.status === 'success') {
          dispatch(
            receiveService({
              records: res.data.data,
              weekNumber: res.data.week_number,
            })
          );
        } else {
          NotificationMessage({ message: res.data.msg, status: res.data.status });
        }
      } else {
        NotificationMessage({ message: res.message, status: 'warning' });
      }
      dispatch(setFetching(false));
    })
    .catch((err) => {
      dispatch(setFetching(false));
      NotificationMessage({ message: err.toString(), status: 'error' });
    });
};

const dynamicPageTrainingCalenderReducer = dynamicPageTrainingCalenderSlice.reducer;

export default dynamicPageTrainingCalenderReducer;
